import React from 'react'
import { Link } from 'react-router-dom'
import CardUI from '../../../widgets/layout/CardUI.js'
import IconButtonUI from '../../../widgets/action/IconButtonUI.js'
import SuperUserLoanPageUI from '../../../templates/SuperUserLoanPageUI.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI.js'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI.js'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI.js'
import SpinnerUI from '../../../widgets/output/SpinnerUI.js'
import FloatingMessageUI from '../../../widgets/form/FloatingMessageUI.js'
import LoanDocumentNavSF from '../../../components/superUser/loan/LoanDocumentNavSF.js'

const ResolutionsPageUI = ({ context, errorList, loan, resolutions, onRefreshClick,
  onSendEsignClick, esignSubmitted, esignErrorList, successMsg
}) =>
  <SuperUserLoanPageUI context={context} className='pg_su_ftl'
    backLink={`/su/${loan && loan.status === 'closed' ? 'closedLoans' : 'loans'}`}
    headerText={loan ? (loan.account.accountName + ' ' + (loan.loanName || '')) : 'Loan'}
    centered={!resolutions || !errorList} loan={loan} page='loanDoc'
    dimension='w1600'
  >
    {
      (!resolutions || !errorList) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      resolutions &&
      <div>
        <LRTableActionsUI location='top'
          left={
            <span className='g_flex_left g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              <span className='g_m_left_100 g_large'><b>Loan documents</b></span>
            </span>
          }
          right={<span />}
        />

        <LoanDocumentNavSF context={context} loan={loan} documentType='resolutions' />

        <div className='g_m_top_50'>
          <span className='g_flex_h g_flex_right'>
            <SpinnerUI show={esignSubmitted} />
            <Link to='#' className='g_m_left_50' onClick={onSendEsignClick}>Send for eSigning</Link>
          </span>
          <FloatingMessageUI errorList={esignErrorList} success={successMsg} />
        </div>

        <div className='g_flex_h g_flex_top g_flex_left g_m_top_50'>
          <CardUI title='Resolutions'>
            <div>
              <span dangerouslySetInnerHTML={{ __html: resolutions }} />
            </div>
          </CardUI>
        </div>

      </div>
    }
  </SuperUserLoanPageUI>


export default ResolutionsPageUI
